import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_5ng28zx6sc: FaireBrandEntity = {
  token: "b_5ng28zx6sc",
  type: "brand",
  name: "FreshCut Paper LLC",
  avatarUrl:
    "https://cdn.faire.com/fastly/9f559ef2aafea05874f457b221df84547fbf3ac674daa8fbfbc6ce432a31917b.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/05c2afbd34516eb27505c7f48804581f9887f9f5b41a7888c4b475e99df13463.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/9f559ef2aafea05874f457b221df84547fbf3ac674daa8fbfbc6ce432a31917b.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/05c2afbd34516eb27505c7f48804581f9887f9f5b41a7888c4b475e99df13463.jpeg",
  location: "Concord, MA, USA",
  minimumOrderDollars: 250,
  rating: 4.9,
  reviewCount: 502,
  isInsider: true,
  description:
    "Created by renowned designer Peter Hewitt, FreshCut Paper bouquets are a contemporary, design forward\nsolution to sending flowers and sharing joy all while treading lightly on the earth. \n\nStunning, life-sized, earth-friendly, pop-up floral bouquets. Far more than a card, our colorful bouquets are a \nmemorable way to celebrate birthdays, holidays, milestones, express thanks, or just “thinking of you”. The \nexquisitely detailed, botanical designs ensure that these colorful bouquets will find a lasting place in every home.\n",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:50:56.584Z",
    importedBy: "entity-db-cli",
  },
};
